module.exports = __webpack_public_path__ + "media/images/red-left-quote-1d8483c1b0aa637b7cdd292f1b6e3008.svg";